import Search from '@mui/icons-material/Search';
import { Chip, InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTasksFilters } from '../hooks/useTasksFilters';

export const AllTasksFilters: React.FC = () => {
  const { formatMessage } = useIntl();
  const {
    search,
    setSearch,
    ownershipFilter,
    setOwnershipFilter,
    timelineFilter,
    setTimelineFilter
  } = useTasksFilters();

  return (
    <Stack gap={1}>
      <TextField
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder={formatMessage({ id: 'Search tasks' })}
        size='small'
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <Search fontSize='small' />
              </InputAdornment>
            )
          }
        }}
      />

      <Stack direction='row' gap={1} flexWrap='wrap'>
        <Chip
          label={formatMessage({ id: 'My tasks' })}
          color={ownershipFilter === 'mine' ? 'primary' : 'default'}
          onClick={() => setOwnershipFilter('mine')}
          variant={ownershipFilter === 'mine' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'All tasks' })}
          color={ownershipFilter === 'all' ? 'primary' : 'default'}
          onClick={() => setOwnershipFilter('all')}
          variant={ownershipFilter === 'all' ? 'filled' : 'outlined'}
        />
      </Stack>

      <Stack direction='row' gap={1} flexWrap='wrap'>
        <Chip
          label={formatMessage({ id: 'Today' })}
          color={timelineFilter === 'today' ? 'primary' : 'default'}
          onClick={() => setTimelineFilter('today')}
          variant={timelineFilter === 'today' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'Upcoming' })}
          color={timelineFilter === 'upcoming' ? 'primary' : 'default'}
          onClick={() => setTimelineFilter('upcoming')}
          variant={timelineFilter === 'upcoming' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'Completed' })}
          color={timelineFilter === 'completed' ? 'primary' : 'default'}
          onClick={() => setTimelineFilter('completed')}
          variant={timelineFilter === 'completed' ? 'filled' : 'outlined'}
        />
      </Stack>
    </Stack>
  );
};

